import { render, staticRenderFns } from "./layout_sidebar.vue?vue&type=template&id=4e24310a&scoped=true"
import script from "./layout_sidebar.vue?vue&type=script&lang=js"
export * from "./layout_sidebar.vue?vue&type=script&lang=js"
import style0 from "./layout_sidebar.vue?vue&type=style&index=0&id=4e24310a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e24310a",
  null
  
)

export default component.exports